export default angular.module('FrontRoyal.ProjectGroup', []);
